import { useState } from 'react'

import {
  useCheckMatchedImages,
  useUploadMedia,
} from '../../../hooks/apiHooks/twinHooks'
import { useTwinData } from '../../../hooks/storeHooks/useTwin'

export const useMatchImages = () => {
  const [isMatched, setIsMatched] = useState<boolean | null>(null)
  const { previewOriginalUrl } = useTwinData()

  const { mutateAsync: checkMatchedImages, isPending: isChecking } =
    useCheckMatchedImages()
  const { mutateAsync: uploadMedia, isPending: isUploading } = useUploadMedia()

  const uploadValidationImage = async (blob: Blob) => {
    try {
      const url =
        (await uploadMedia({
          file: blob,
          type: 'image',
          name: `${Date.now()}-selfie.jpeg`,
        })) || ''

      if (url) {
        await handleCheckMatchedImages(url)
      }
    } catch (error) {
      console.error('Error uploading image:', error)
    }
  }

  const handleCheckMatchedImages = async (imageFormConsent: string) => {
    try {
      setIsMatched(null)
      const { is_match } = await checkMatchedImages({
        idPhotoUrl: imageFormConsent,
        selfiePhotoUrl: previewOriginalUrl || '',
      })
      setIsMatched(is_match)
    } catch (error) {
      console.error('Error checking matched images:', error)
    }
  }

  return {
    isMatched,
    isMatchProcessing: isChecking || isUploading,
    handleCheckMatchedImages,
    uploadValidationImage,
  }
}
